export const CO_OWNERSHIP = "co_ownership"
export const SALE = "sale"
